module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Authorship and Place within the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Addressees: “A Community in Crisis”? Location and Date?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Integrity, Genre, and Distinctive Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Uniqueness of Christ in Comparison with Other Mediators between God and Humankind (1:1–4:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rhetorical Recital of Christ’s Role and Rank: Revealer, Representation, Royal High Priest (1:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biblical Exposition with a Practical Warning: Christ, Angels, and Humanity (1:5–2:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ Compared with Moses as Son with Servant (3:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Entering into the Rest”: A Wordplay on Jesus-Joshua (4:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ as Unique High Priest and All-Sufficient Sacrifice (4:14–10:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ Fully and Uniquely Qualified as High Priest (4:14–5:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immaturity Rebuked and Perseverance and Confidence Encouraged (5:11–6:20)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Order of Melchizedek: Christ and Levitical Priests (7:1–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The High-Priestly Work of Christ: Sacrifice and Covenant Promise (8:1–10:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forward in Fearless Faith, Fellowship, and Faithfulness (10:19–13:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assurance and Perseverance: The Two-Sided Implications of Covenant (10:19–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith Defined and Faith in Action (11:1–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Call to Endurance and Faithfulness (12:1–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix on Practical Attitudes Demanded by the Pilgrim Calling (13:1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0